export enum SystemTaskTypeEnum {
  AI = 'AI',
  Manual = 'Manual'
}
